import { render, staticRenderFns } from "./tiny-check.vue?vue&type=template&id=d5ad9ba6&"
import script from "./tiny-check.vue?vue&type=script&lang=js&"
export * from "./tiny-check.vue?vue&type=script&lang=js&"
import style0 from "./tiny-check.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports